import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getSzakLetszamAdatok, createSzakLetszamAdatok, updateSzakLetszamAdatok, getSzak } from "../../apis/SzakokFinder";
import SideTile from "../SideTile";
import Modal from 'react-modal';
// import "../../components/Ujszak.css";
// import "./SzakLetszamAdatok.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { SZAKLETSZAMADATOK_TRANSLATIONS } from './SzakLetszamAdatokTranslations';
import {
    HALLGATOI_LETSZAMTREND_OPTIONS,
    ELOREHALADASI_ARANY_OPTIONS,
    PROBLEMAS_TANTARGYAK_ELOFORDULASA_OPTIONS,
    PROBLEMAK_JELLEGE_OPTIONS,
    TELJESITMENY_ERTEKELES_OPTIONS,
    JELENTKEZESI_TREND_OPTIONS,
    PONTHATARAK_ALAKULASA_OPTIONS,
    MUNKAREND_TREND_OPTIONS,
    FINANSZIROZAS_MEGOSZLAS_OPTIONS,
    FOLDRAJZI_VONZASKOR_OPTIONS,
    DIPLOMAS_FOGLALKOZTATAS_OPTIONS,
    VEGZETTSEG_SZERINTI_ARANY_OPTIONS,
    JOVEDELMI_SZINT_OPTIONS
} from './SzakLetszamAdatokOptions';

const hallgatoiEredmenyessegUrl = 'https://app.powerbi.com/view?r=eyJrIjoiODZlNzA0MjgtZmQwZi00ODM3LTgxNTItNjMxYjU4YWY5YzQ3IiwidCI6ImJhM2JmYTgyLTM0MzctNDZlNi04MTVjLWQ5ODc4MTRlZWFlZSIsImMiOjh9';
const felveteliAdatokUrl = 'https://app.powerbi.com/view?r=eyJrIjoiZWEwMzEzMjMtZmQ5ZS00ZGIxLTg1NGEtOWMxMzNlY2NjZmQ4IiwidCI6ImJhM2JmYTgyLTM0MzctNDZlNi04MTVjLWQ5ODc4MTRlZWFlZSIsImMiOjh9';


const SzakLetszamAdatokContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();


    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [szakLetszamAdatok, setSzakLetszamAdatok] = useState({
        filling_status: 1
    });

    // Radio button state
    const [hallgatoiLetszamtrendValasztas, setHallgatoiLetszamtrendValasztas] = useState("");
    const [hallgatoiLetszamtrendMegjegyzes, setHallgatoiLetszamtrendMegjegyzes] = useState("");
    const [elorehaladasiAranyValasztas, setElorehaladasiAranyValasztas] = useState("");
    const [elorehaladasiAranyMegjegyzes, setElorehaladasiAranyMegjegyzes] = useState("");
    const [problemasTantargyakElofodulasaValasztas, setProblemasTantargyakElofodulasaValasztas] = useState("");
    const [listazando, setListazando] = useState("");
    const [problemakJellegeValasztas, setProblemakJellegeValasztas] = useState([]);
    const [problemakJellegeMegjegyzes, setProblemakJellegeMegjegyzes] = useState("");
    const [javasoltBeavatkozasok, setJavasoltBeavatkozasok] = useState("");
    const [teljesitmenyErtekelesValasztas, setTeljesitmenyErtekelesValasztas] = useState("");
    const [jelentkezesiTrendValasztas, setJelentkezesiTrendValasztas] = useState("");
    const [ponthatArakAlakValasztas, setPonthatArakAlakValasztas] = useState("");
    const [munkarendTrendValasztas, setMunkarendTrendValasztas] = useState("");
    const [finanszirozasMegoszlasValasztas, setFinanszirozasMegoszlasValasztas] = useState("");
    const [foldrajziVonzaskorValasztas, setFoldrajziVonzaskorValasztas] = useState([]);
    const [diplomasFoglalkoztatasValasztas, setDiplomasFoglalkoztatasValasztas] = useState("");
    const [vegzettsegSzerintiAranyValasztas, setVegzettsegSzerintiAranyValasztas] = useState("");
    const [jovedelmiSzintValasztas, setJovedelmiSzintValasztas] = useState("");

    const [isNew, setIsNew] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };
    
    // Get translations and options for current language
    const t = loading ? {} : (SZAKLETSZAMADATOK_TRANSLATIONS[language] || SZAKLETSZAMADATOK_TRANSLATIONS.hu);
    const hallgatoiLetszamtrendOptions = loading ? [] : (HALLGATOI_LETSZAMTREND_OPTIONS[language] || HALLGATOI_LETSZAMTREND_OPTIONS.hu);
    const elorehaladasiAranyOptions = loading ? [] : (ELOREHALADASI_ARANY_OPTIONS[language] || ELOREHALADASI_ARANY_OPTIONS.hu);
    const problemasTantargyakElofordulasaOptions = loading ? [] : (PROBLEMAS_TANTARGYAK_ELOFORDULASA_OPTIONS[language] || PROBLEMAS_TANTARGYAK_ELOFORDULASA_OPTIONS.hu);
    const problemakJellegeOptions = loading ? [] : (PROBLEMAK_JELLEGE_OPTIONS[language] || PROBLEMAK_JELLEGE_OPTIONS.hu);
    const teljesitmenyErtekelesOptions = loading ? [] : (TELJESITMENY_ERTEKELES_OPTIONS[language] || TELJESITMENY_ERTEKELES_OPTIONS.hu);
    const jelentkezesiTrendOptions = loading ? [] : (JELENTKEZESI_TREND_OPTIONS[language] || JELENTKEZESI_TREND_OPTIONS.hu);
    const ponthatArakAlakOptions = loading ? [] : (PONTHATARAK_ALAKULASA_OPTIONS[language] || PONTHATARAK_ALAKULASA_OPTIONS.hu);
    const munkarendTrendOptions = loading ? [] : (MUNKAREND_TREND_OPTIONS[language] || MUNKAREND_TREND_OPTIONS.hu);
    const finanszirozasMegoszlasOptions = loading ? [] : (FINANSZIROZAS_MEGOSZLAS_OPTIONS[language] || FINANSZIROZAS_MEGOSZLAS_OPTIONS.hu);
    const foldrajziVonzaskorOptions = loading ? [] : (FOLDRAJZI_VONZASKOR_OPTIONS[language] || FOLDRAJZI_VONZASKOR_OPTIONS.hu);
    const diplomasFoglalkoztatasOptions = loading ? [] : (DIPLOMAS_FOGLALKOZTATAS_OPTIONS[language] || DIPLOMAS_FOGLALKOZTATAS_OPTIONS.hu);
    const vegzettsegSzerintiAranyOptions = loading ? [] : (VEGZETTSEG_SZERINTI_ARANY_OPTIONS[language] || VEGZETTSEG_SZERINTI_ARANY_OPTIONS.hu);
    const jovedelmiSzintOptions = loading ? [] : (JOVEDELMI_SZINT_OPTIONS[language] || JOVEDELMI_SZINT_OPTIONS.hu);

    const isFinalized = szakLetszamAdatok.filling_status === 3;

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const szakLetszamAdatokResponse = await getSzakLetszamAdatok(szakId);
                if (szakLetszamAdatokResponse.data.data.szakLetszamAdatok) {
                    const data = szakLetszamAdatokResponse.data.data.szakLetszamAdatok;
                    setSzakLetszamAdatok(data);
                    
                    // Load radio button selections from JSONB
                    if (data.hallgatoi_letszamtrend_valasztas) {
                        setHallgatoiLetszamtrendValasztas(data.hallgatoi_letszamtrend_valasztas.selected || "");
                    }
                    if (data.hallgatoi_letszamtrend_megjegyzes) {
                        setHallgatoiLetszamtrendMegjegyzes(data.hallgatoi_letszamtrend_megjegyzes);
                    }
                    if (data.elorehaladasi_arany_valasztas) {
                        setElorehaladasiAranyValasztas(data.elorehaladasi_arany_valasztas.selected || "");
                    }
                    if (data.elorehaladasi_arany_megjegyzes) {
                        setElorehaladasiAranyMegjegyzes(data.elorehaladasi_arany_megjegyzes);
                    }
                    if (data.problemas_tantargyak_elofordulasa_valasztas) {
                        setProblemasTantargyakElofodulasaValasztas(data.problemas_tantargyak_elofordulasa_valasztas.selected || "");
                    }
                    if (data.listazando) {
                        setListazando(data.listazando);
                    }
                    if (data.problemak_jellege_valasztas) {
                        setProblemakJellegeValasztas(data.problemak_jellege_valasztas.selected || []);
                    }
                    if (data.problemak_jellege_megjegyzes) {
                        setProblemakJellegeMegjegyzes(data.problemak_jellege_megjegyzes);
                    }
                    if (data.javasolt_beavatkozasok) {
                        setJavasoltBeavatkozasok(data.javasolt_beavatkozasok);
                    }
                    if (data.teljesitmeny_ertekeles_valasztas) {
                        setTeljesitmenyErtekelesValasztas(data.teljesitmeny_ertekeles_valasztas.selected || "");
                    }
                    if (data.jelentkezesi_trend_valasztas) {
                        setJelentkezesiTrendValasztas(data.jelentkezesi_trend_valasztas.selected || "");
                    }
                    if (data.ponthatarak_alakulasa_valasztas) {
                        setPonthatArakAlakValasztas(data.ponthatarak_alakulasa_valasztas.selected || "");
                    }
                    if (data.munkarend_trend_valasztas) {
                        setMunkarendTrendValasztas(data.munkarend_trend_valasztas.selected || "");
                    }
                    if (data.finanszirozas_megoszlas_valasztas) {
                        setFinanszirozasMegoszlasValasztas(data.finanszirozas_megoszlas_valasztas.selected || "");
                    }
                    if (data.foldrajzi_vonzaskor_valasztas) {
                        setFoldrajziVonzaskorValasztas(data.foldrajzi_vonzaskor_valasztas.selected || []);
                    }
                    if (data.diplomas_foglalkoztatas_valasztas) {
                        setDiplomasFoglalkoztatasValasztas(data.diplomas_foglalkoztatas_valasztas.selected || "");
                    }
                    if (data.vegzettseg_szerinti_arany_valasztas) {
                        setVegzettsegSzerintiAranyValasztas(data.vegzettseg_szerinti_arany_valasztas.selected || "");
                    }
                    if (data.jovedelmi_szint_valasztas) {
                        setJovedelmiSzintValasztas(data.jovedelmi_szint_valasztas.selected || "");
                    }
                    
                    setIsNew(false);
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    const newRecord = {
                        filling_status: 1,
                    };
                    try {
                        await createSzakLetszamAdatok(szakId, newRecord);
                        setSzakLetszamAdatok(newRecord);
                        window.location.reload();
                    } catch (createError) {
                        console.error("Error creating new record:", createError);
                    }
                } else {
                    console.log("Error fetching data:", error);
                }
            }
        };
        fetchData();
    }, [szakId]);

    const handleChange = (field, value) => {
        setSzakLetszamAdatok(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { ...szakLetszamAdatok, filling_status: 2 }; // Always save with status 2
            try {
                if (isNew) {
                    await createSzakLetszamAdatok(szakId, updatedData);
                } else {
                    await updateSzakLetszamAdatok(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [szakLetszamAdatok, isNew, szakId, registerSaveHandler, unregisterSaveHandler]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { 
            ...szakLetszamAdatok, 
            filling_status: status,
            hallgatoi_letszamtrend_valasztas: buildRadioData(hallgatoiLetszamtrendValasztas, hallgatoiLetszamtrendOptions),
            hallgatoi_letszamtrend_megjegyzes: hallgatoiLetszamtrendMegjegyzes,
            elorehaladasi_arany_valasztas: buildRadioData(elorehaladasiAranyValasztas, elorehaladasiAranyOptions),
            elorehaladasi_arany_megjegyzes: elorehaladasiAranyMegjegyzes,
            problemas_tantargyak_elofordulasa_valasztas: buildRadioData(problemasTantargyakElofodulasaValasztas, problemasTantargyakElofordulasaOptions),
            listazando: problemasTantargyakElofodulasaValasztas === 'nincs_problemas' ? '' : listazando,
            problemak_jellege_valasztas: problemasTantargyakElofodulasaValasztas === 'nincs_problemas' ? null : buildMultiSelectData(problemakJellegeValasztas, problemakJellegeOptions),
            problemak_jellege_megjegyzes: problemasTantargyakElofodulasaValasztas === 'nincs_problemas' ? '' : problemakJellegeMegjegyzes,
            javasolt_beavatkozasok: problemasTantargyakElofodulasaValasztas === 'nincs_problemas' ? '' : javasoltBeavatkozasok,
            teljesitmeny_ertekeles_valasztas: buildRadioData(teljesitmenyErtekelesValasztas, teljesitmenyErtekelesOptions),
            jelentkezesi_trend_valasztas: buildRadioData(jelentkezesiTrendValasztas, jelentkezesiTrendOptions),
            ponthatarak_alakulasa_valasztas: buildRadioData(ponthatArakAlakValasztas, ponthatArakAlakOptions),
            munkarend_trend_valasztas: buildRadioData(munkarendTrendValasztas, munkarendTrendOptions),
            finanszirozas_megoszlas_valasztas: buildRadioData(finanszirozasMegoszlasValasztas, finanszirozasMegoszlasOptions),
            foldrajzi_vonzaskor_valasztas: buildMultiSelectData(foldrajziVonzaskorValasztas, foldrajziVonzaskorOptions),
            diplomas_foglalkoztatas_valasztas: buildRadioData(diplomasFoglalkoztatasValasztas, diplomasFoglalkoztatasOptions),
            vegzettseg_szerinti_arany_valasztas: buildRadioData(vegzettsegSzerintiAranyValasztas, vegzettsegSzerintiAranyOptions),
            jovedelmi_szint_valasztas: buildRadioData(jovedelmiSzintValasztas, jovedelmiSzintOptions)
        };

        try {
            if (isNew) {
                await createSzakLetszamAdatok(szakId, updatedData);
            } else {
                await updateSzakLetszamAdatok(szakId, updatedData);
            }

            window.location.reload(); // Reload the page after save or finalize.
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/versenytars-elemzes`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/oktatas`);
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // Check if radio buttons are selected
        const hasRadioSelection = hallgatoiLetszamtrendValasztas !== "" && 
                                   elorehaladasiAranyValasztas !== "" &&
                                   problemasTantargyakElofodulasaValasztas !== "" &&
                                   teljesitmenyErtekelesValasztas !== "" &&
                                   jelentkezesiTrendValasztas !== "" &&
                                   ponthatArakAlakValasztas !== "" &&
                                   munkarendTrendValasztas !== "" &&
                                   finanszirozasMegoszlasValasztas !== "" &&
                                   foldrajziVonzaskorValasztas.length > 0 &&
                                   diplomasFoglalkoztatasValasztas !== "" &&
                                   vegzettsegSzerintiAranyValasztas !== "" &&
                                   jovedelmiSzintValasztas !== "";

        // If "Nincs problémás tantárgy" is selected, no additional validation needed for section 9.3
        const isSection93Valid = problemasTantargyakElofodulasaValasztas === 'nincs_problemas' ||
            (hasContent(listazando) && 
             problemakJellegeValasztas.length > 0 && 
             hasContent(javasoltBeavatkozasok));

        return (
            hasRadioSelection &&
            isSection93Valid
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3);
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts?.requiredFields || "Minden szöveges mezőt ki kell tölteni!");
            setShowAlert(true);
        }
    };

    const handleUndoFinalize = (e) => {
        handleSubmit(e, 2); // Set status back to 2 to allow editing again
    };

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    {/* 9.1 Hallgatói létszám mérleg */}
                    <div className="card">
                        <h2>{t.section91.title}</h2>
                         <p>{t.section91.source} <a href="https://munkatars.sze.hu/szakletszam-adatok-bi" target="_blank" rel="noopener noreferrer">https://munkatars.sze.hu/szakletszam-adatok-bi</a></p>
                        <div className="form-group">
                            {hallgatoiLetszamtrendOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`hallgatoi_letszamtrend_${option.value}`}
                                        name="hallgatoi_letszamtrend"
                                        value={option.value}
                                        checked={hallgatoiLetszamtrendValasztas === option.value}
                                        onChange={(e) => setHallgatoiLetszamtrendValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`hallgatoi_letszamtrend_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section91.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="hallgatoi_letszamtrend_megjegyzes"
                                value={hallgatoiLetszamtrendMegjegyzes}
                                onChange={setHallgatoiLetszamtrendMegjegyzes}
                                disabled={isFinalized}
                            />
                        </div>
                    </div>

                    {/* 9.2 Felvételi adatok */}
                    <div className="card">
                        <h2>{t.section92.title}</h2>
                         <p>{t.section92.source} <a href={hallgatoiEredmenyessegUrl} target="_blank" rel="noopener noreferrer">{hallgatoiEredmenyessegUrl}</a></p>
                        <p>{t.section92.info}</p>
                        <h4>{t.section92.subtitle}</h4>
                        <div className="form-group">
                            {elorehaladasiAranyOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`elorehaladasi_arany_${option.value}`}
                                        name="elorehaladasi_arany"
                                        value={option.value}
                                        checked={elorehaladasiAranyValasztas === option.value}
                                        onChange={(e) => setElorehaladasiAranyValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`elorehaladasi_arany_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section92.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="elorehaladasi_arany_megjegyzes"
                                value={elorehaladasiAranyMegjegyzes}
                                onChange={setElorehaladasiAranyMegjegyzes}
                                disabled={isFinalized}
                            />
                        </div>
                    </div>

                    {/* 9.3 Kritikus tárgyak */}
                    <div className="card">
                        <h2>{t.section93.title}</h2>
                         <p>{t.section93.source} <a href="https://seafile.sze.hu/f/d79a030031814b768df1/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/d79a030031814b768df1/</a></p>
                        <p style={{ whiteSpace: 'pre-line' }}>{t.section93.info}</p>
                        <h4>{t.section93.subtitle}</h4>
                        <div className="form-group">
                            {problemasTantargyakElofordulasaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={option.value}
                                        name="problemas_tantargyak_elofordulasa"
                                        value={option.value}
                                        checked={problemasTantargyakElofodulasaValasztas === option.value}
                                        onChange={(e) => {
                                            setProblemasTantargyakElofodulasaValasztas(e.target.value);
                                            // Clear all dependent fields when "Nincs problémás" is selected
                                            if (option.value === 'nincs_problemas') {
                                                setListazando("");
                                                setProblemakJellegeValasztas([]);
                                                setProblemakJellegeMegjegyzes("");
                                                setJavasoltBeavatkozasok("");
                                            }
                                        }}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={option.value}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* Conditional section - only show if NOT "Nincs problémás tantárgy" */}
                        {problemasTantargyakElofodulasaValasztas !== '' && problemasTantargyakElofodulasaValasztas !== 'nincs_problemas' && (
                            <>
                                <h4>{t.section93.listLabel}</h4>
                                <div className="form-group">
                                    <RichTextEditor
                                        name="listazando"
                                        value={listazando}
                                        onChange={setListazando}
                                        disabled={isFinalized}
                                    />
                                </div>

                                <h4>{t.section93.typeLabel}</h4>
                                <div className="form-group">
                                    {problemakJellegeOptions.map((option) => (
                                        <div className="checkbox-group" key={option.value}>
                                            <input
                                                type="checkbox"
                                                id={`problemak_jellege_${option.value}`}
                                                name="problemak_jellege"
                                                value={option.value}
                                                checked={problemakJellegeValasztas.includes(option.value)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setProblemakJellegeValasztas([...problemakJellegeValasztas, e.target.value]);
                                                    } else {
                                                        setProblemakJellegeValasztas(problemakJellegeValasztas.filter(v => v !== e.target.value));
                                                    }
                                                }}
                                                disabled={isFinalized}
                                            />
                                            <label htmlFor={`problemak_jellege_${option.value}`}>{option.label}</label>
                                        </div>
                                    ))}
                                </div>

                                <h4>{t.section93.typeNoteLabel}</h4>
                                <div className="form-group">
                                    <RichTextEditor
                                        name="problemak_jellege_megjegyzes"
                                        value={problemakJellegeMegjegyzes}
                                        onChange={setProblemakJellegeMegjegyzes}
                                        disabled={isFinalized}
                                    />
                                </div>

                                <h4>{t.section93.interventionLabel}</h4>
                                <div className="form-group">
                                    <RichTextEditor
                                        name="javasolt_beavatkozasok"
                                        value={javasoltBeavatkozasok}
                                        onChange={setJavasoltBeavatkozasok}
                                        disabled={isFinalized}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    {/* 9.4 Teljesítmény értékelése */}
                    <div className="card">
                        <h2>{t.section94.title}</h2>
                         <p>{t.section94.source} <a href={hallgatoiEredmenyessegUrl} target="_blank" rel="noopener noreferrer">{hallgatoiEredmenyessegUrl}</a></p>
                        <h4>{t.section94.subtitle}</h4>
                        <div className="form-group">
                            {teljesitmenyErtekelesOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`teljesitmeny_ertekeles_${option.value}`}
                                        name="teljesitmeny_ertekeles"
                                        value={option.value}
                                        checked={teljesitmenyErtekelesValasztas === option.value}
                                        onChange={(e) => setTeljesitmenyErtekelesValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`teljesitmeny_ertekeles_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 9.5 Felvételi adatok */}
                    <div className="card">
                        <h2>{t.section95.title}</h2>
                         <p>{t.section95.subtitle}</p>    
                         <p>{t.section95.source} <a href={felveteliAdatokUrl} target="_blank" rel="noopener noreferrer">{felveteliAdatokUrl}</a></p>
                        {/* 9.5.1 Jelentkezési trend értékelése */}
                        <h4>{t.section95.subtitle951}</h4>
                        <p>{t.section95.source951}</p>
                        <div className="form-group">
                            {jelentkezesiTrendOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`jelentkezesi_trend_${option.value}`}
                                        name="jelentkezesi_trend"
                                        value={option.value}
                                        checked={jelentkezesiTrendValasztas === option.value}
                                        onChange={(e) => setJelentkezesiTrendValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`jelentkezesi_trend_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* 9.5.2 A felvételi ponthatárok alakulása */}
                        <h4>{t.section95.subtitle952}</h4>
                        <p>{t.section95.source952}</p>
                        <div className="form-group">
                            {ponthatArakAlakOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`ponthatarak_alakulasa_${option.value}`}
                                        name="ponthatarak_alakulasa"
                                        value={option.value}
                                        checked={ponthatArakAlakValasztas === option.value}
                                        onChange={(e) => setPonthatArakAlakValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`ponthatarak_alakulasa_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* 9.5.3 Felvettek munkarend szerinti trendje */}
                        <h4>{t.section95.subtitle953}</h4>
                        <p>{t.section95.source953}</p>
                        <div className="form-group">
                            {munkarendTrendOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`munkarend_trend_${option.value}`}
                                        name="munkarend_trend"
                                        value={option.value}
                                        checked={munkarendTrendValasztas === option.value}
                                        onChange={(e) => setMunkarendTrendValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`munkarend_trend_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* 9.5.4 Felvettek megoszlása finanszírozási forma szerint */}
                        <h4>{t.section95.subtitle954}</h4>
                        <p>{t.section95.source954}</p>
                        <div className="form-group">
                            {finanszirozasMegoszlasOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`finanszirozas_megoszlas_${option.value}`}
                                        name="finanszirozas_megoszlas"
                                        value={option.value}
                                        checked={finanszirozasMegoszlasValasztas === option.value}
                                        onChange={(e) => setFinanszirozasMegoszlasValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`finanszirozas_megoszlas_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* 9.5.5 A felvettek földrajzi megoszlása */}
                        <h4>{t.section95.subtitle955}</h4>
                        <p>{t.section95.source955}</p>
                        <p>{t.section95.subsubtitle955}</p>
                        <div className="form-group">
                            {foldrajziVonzaskorOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`foldrajzi_vonzaskor_${option.value}`}
                                        name="foldrajzi_vonzaskor"
                                        value={option.value}
                                        checked={foldrajziVonzaskorValasztas.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setFoldrajziVonzaskorValasztas([...foldrajziVonzaskorValasztas, option.value]);
                                            } else {
                                                setFoldrajziVonzaskorValasztas(foldrajziVonzaskorValasztas.filter(val => val !== option.value));
                                            }
                                        }}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`foldrajzi_vonzaskor_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        
                    </div>

                    {/* 9.6 DPR adatok */}
                    <div className="card">
                        <h2>{t.section96.title}</h2>
                         <p>{t.section96.source} <a href="https://munkatars.sze.hu/diplomas-palyakovetesi-rendszer-bi" target="_blank" rel="noopener noreferrer">https://munkatars.sze.hu/diplomas-palyakovetesi-rendszer-bi</a> {t.section96.subtitle}</p>
                         <p>{language === 'en' ? 'National graduate tracking data:' : 'Országos DPR adatok:'} <a href="https://www.diplomantul.hu/adminisztrativ-adatbazisok-egyesitese" target="_blank" rel="noopener noreferrer">https://www.diplomantul.hu/adminisztrativ-adatbazisok-egyesitese</a></p>
                        {/* 9.6.1 Diplomás foglalkoztatottság értékelése */}
                        <h4>{t.section96.subtitle961}</h4>
                        <div className="form-group">
                            {diplomasFoglalkoztatasOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`diplomas_foglalkoztatas_${option.value}`}
                                        name="diplomas_foglalkoztatas"
                                        value={option.value}
                                        checked={diplomasFoglalkoztatasValasztas === option.value}
                                        onChange={(e) => setDiplomasFoglalkoztatasValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`diplomas_foglalkoztatas_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* 9.6.2 A végzettségének megfelelő szakmában dolgozók aránya */}
                        <h4>{t.section96.subtitle962}</h4>
                        <div className="form-group">
                            {vegzettsegSzerintiAranyOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`vegzettseg_szerinti_arany_${option.value}`}
                                        name="vegzettseg_szerinti_arany"
                                        value={option.value}
                                        checked={vegzettsegSzerintiAranyValasztas === option.value}
                                        onChange={(e) => setVegzettsegSzerintiAranyValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`vegzettseg_szerinti_arany_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        {/* 9.6.3 Jövedelmi szint értékelése */}
                        <h4>{t.section96.subtitle963}</h4>
                        <div className="form-group">
                            {jovedelmiSzintOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`jovedelmi_szint_${option.value}`}
                                        name="jovedelmi_szint"
                                        value={option.value}
                                        checked={jovedelmiSzintValasztas === option.value}
                                        onChange={(e) => setJovedelmiSzintValasztas(e.target.value)}
                                        disabled={isFinalized}
                                    />
                                    <label htmlFor={`jovedelmi_szint_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={isFinalized || szakStatus >= 2}>{t.buttons.save}</button>
                        {!isFinalized ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons.finalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleUndoFinalize} disabled={szakStatus >= 2}>{t.buttons.unfinalize}</button>
                        )}
                    </div>
                </form>
            </div>
            <Modal
                isOpen={!!selectedImage} 
                onRequestClose={() => setSelectedImage(null)}
                contentLabel={t.modal.imageAlt}
                className="image-modal"
                overlayClassName="image-modal-overlay"
            >
                {selectedImage && (
                    <div>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${selectedImage}`} alt={t.modal.imageAlt} className="modal-image"/>
                        <button onClick={() => setSelectedImage(null)} className="modal-close-button">
                            <i className="material-icons">close</i>
                        </button>
                    </div>
                )}
            </Modal>
        </div>
        </div>
    );
};

// Wrapper component that provides language context
const SzakLetszamAdatok = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                const response = await getSzak(szakId);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <SzakLetszamAdatokContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default SzakLetszamAdatok;
